import { LanguageSelector, LinkedJobibot, ProvidedMainNavConfigContext } from '@/ui'
import {
	type SubscriptionAccessDataReason,
	subscriptionAccessDataReason,
	userDataRole,
	useUserIndex,
} from '@jobilla/nexus-sdk'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

export function PaywallNav() {
	const { orgSwitcher, profileLinker } = useContext(ProvidedMainNavConfigContext)

	return (
		<div className="sticky top-0 z-20 flex h-[55px] items-center justify-between border-b border-grey-100 bg-white px-10">
			<LinkedJobibot size={28} />
			<div className="flex items-center gap-4">
				{orgSwitcher}
				<LanguageSelector />
				{profileLinker({})}
			</div>
		</div>
	)
}

export function PaywallReason({ reason }: { reason: SubscriptionAccessDataReason }) {
	const { t } = useTranslation('common')

	const message = reason === subscriptionAccessDataReason['subscription-inactive']
		? t('subscribe.paywall.inactive')
		: t('subscribe.paywall.noSubscription')

	return (
		<div className="mx-auto mb-8 max-w-2xl rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-center text-sm text-amber-900">
			{message}
		</div>
	)
}

export function AskAnAdmin() {
	const { t } = useTranslation('common')
	const [copied, setCopied] = useState(false)
	const { data: admins } = useUserIndex({ 'filter[role]': userDataRole.admin })
	const adminNames = (admins?.data ?? []).map((admin) => admin.name || admin.email).filter(Boolean)

	async function copyLink() {
		try {
			await navigator.clipboard.writeText(window.location.href)
			setCopied(true)
		} catch {
			// The browser refused clipboard access; the user can still copy the address bar.
		}
	}

	return (
		<div className="mx-auto max-w-lg space-y-3 text-center text-sm text-grey-600">
			<p>{t('subscribe.noPermission')}</p>
			{adminNames.length > 0
				? (
					<p className="font-medium text-grey-900">
						{t('subscribe.paywall.admins', { admins: adminNames.join(', ') })}
					</p>
				)
				: null}
			<button
				type="button"
				onClick={() => void copyLink()}
				className="cursor-pointer font-medium text-brand-700 hover:underline"
			>
				{copied ? t('subscribe.paywall.linkCopied') : t('subscribe.paywall.copyLink')}
			</button>
		</div>
	)
}
